import { formatDate } from "@gigpro/utils/datetime";
import { type AdminUsersListParams, getAdminUsersListQueryOptions } from "@sidegigllc/api/client";

export type UsersQueryPayload = Omit<AdminUsersListParams, "date_joined" | "last_login"> & {
  date_joined?: Date;
  last_login?: Date;
};

export const usersQueryOptions = (params: UsersQueryPayload) =>
  getAdminUsersListQueryOptions({
    ...params,
    last_login: params.last_login ? formatDate(params.last_login, "MM/dd/yyyy") : undefined,
    date_joined: params.date_joined ? formatDate(params.date_joined, "MM/dd/yyyy") : undefined,
  });
